module.exports = __webpack_public_path__ + "img/mtt_5.5.253ed914.png";